/* Generated by npm run content:index. Article copy belongs in ./articles/*.json. */
import type { ContentPage } from './content-pages';
import article1 from './articles/20-pattern-recognition-questions.en.json';
import article2 from './articles/adhd-accommodations-for-iq-testing.en.json';
import article3 from './articles/age-norms-in-iq-testing.en.json';
import article4 from './articles/ai-and-iq-testing.en.json';
import article5 from './articles/albert-einstein-iq.en.json';
import article6 from './articles/analogical-reasoning-explained.en.json';
import article7 from './articles/analogies-practice.en.json';
import article8 from './articles/are-iq-tests-culturally-biased.en.json';
import article9 from './articles/are-iq-tests-timed.en.json';
import article10 from './articles/attention-and-iq-testing.en.json';
import article11 from './articles/average-iq-by-age.en.json';
import article12 from './articles/average-iq-by-country.en.json';
import article13 from './articles/average-iq-in-argentina.en.json';
import article14 from './articles/average-iq-in-argentina.es.json';
import article15 from './articles/bell-curve-and-iq-scores.en.json';
import article16 from './articles/best-time-of-day-for-iq-test.en.json';
import article17 from './articles/bilingualism-and-cognitive-testing.en.json';
import article18 from './articles/bill-gates-iq.en.json';
import article19 from './articles/brain-age-test.en.json';
import article20 from './articles/caffeine-before-an-iq-test.en.json';
import article21 from './articles/can-an-online-iq-score-be-exact.en.json';
import article22 from './articles/can-anxiety-lower-iq-scores.ar.json';
import article23 from './articles/can-anxiety-lower-iq-scores.bn.json';
import article24 from './articles/can-anxiety-lower-iq-scores.en.json';
import article25 from './articles/can-anxiety-lower-iq-scores.es.json';
import article26 from './articles/can-anxiety-lower-iq-scores.fr.json';
import article27 from './articles/can-anxiety-lower-iq-scores.hi.json';
import article28 from './articles/can-anxiety-lower-iq-scores.zh.json';
import article29 from './articles/can-education-increase-iq-scores.en.json';
import article30 from './articles/can-iq-change-over-time.ar.json';
import article31 from './articles/can-iq-change-over-time.bn.json';
import article32 from './articles/can-iq-change-over-time.en.json';
import article33 from './articles/can-iq-change-over-time.es.json';
import article34 from './articles/can-iq-change-over-time.fr.json';
import article35 from './articles/can-iq-change-over-time.hi.json';
import article36 from './articles/can-iq-change-over-time.zh.json';
import article37 from './articles/can-one-score-define-intelligence.en.json';
import article38 from './articles/can-you-improve-your-iq.ar.json';
import article39 from './articles/can-you-improve-your-iq.bn.json';
import article40 from './articles/can-you-improve-your-iq.en.json';
import article41 from './articles/can-you-improve-your-iq.es.json';
import article42 from './articles/can-you-improve-your-iq.fr.json';
import article43 from './articles/can-you-improve-your-iq.hi.json';
import article44 from './articles/can-you-improve-your-iq.zh.json';
import article45 from './articles/can-you-retake-an-iq-test.en.json';
import article46 from './articles/can-you-take-an-iq-test-on-your-phone.en.json';
import article47 from './articles/cattell-horn-carroll-theory-explained.en.json';
import article48 from './articles/ceiling-and-floor-effects-in-iq-testing.en.json';
import article49 from './articles/cognitive-aging-studies.en.json';
import article50 from './articles/cognitive-flexibility-explained.en.json';
import article51 from './articles/cognitive-reserve-explained.en.json';
import article52 from './articles/cognitive-style-quiz.en.json';
import article53 from './articles/color-vision-test.en.json';
import article54 from './articles/comparing-iq-scores-over-time.en.json';
import article55 from './articles/computer-adaptive-intelligence-testing.en.json';
import article56 from './articles/concentration-exercises.en.json';
import article57 from './articles/construct-validity-intelligence-tests.en.json';
import article58 from './articles/crystallized-intelligence.en.json';
import article59 from './articles/cube-rotation-puzzle-strategies.en.json';
import article60 from './articles/culture-fair-iq-tests.en.json';
import article61 from './articles/daily-brain-challenge.en.json';
import article62 from './articles/deductive-reasoning-explained.en.json';
import article63 from './articles/deliberate-practice-and-cognitive-skills.en.json';
import article64 from './articles/do-brain-games-raise-iq.en.json';
import article65 from './articles/do-testing-conditions-affect-iq-scores.en.json';
import article66 from './articles/does-high-iq-always-mean-gifted.en.json';
import article67 from './articles/does-iq-determine-success.en.json';
import article68 from './articles/does-iq-measure-creativity.en.json';
import article69 from './articles/does-iq-measure-potential.en.json';
import article70 from './articles/does-language-affect-iq-test-scores.en.json';
import article71 from './articles/does-music-increase-intelligence.en.json';
import article72 from './articles/does-sleep-affect-iq.ar.json';
import article73 from './articles/does-sleep-affect-iq.bn.json';
import article74 from './articles/does-sleep-affect-iq.en.json';
import article75 from './articles/does-sleep-affect-iq.es.json';
import article76 from './articles/does-sleep-affect-iq.fr.json';
import article77 from './articles/does-sleep-affect-iq.hi.json';
import article78 from './articles/does-sleep-affect-iq.zh.json';
import article79 from './articles/dyslexia-and-iq-testing.en.json';
import article80 from './articles/elon-musk-iq.en.json';
import article81 from './articles/executive-function.en.json';
import article82 from './articles/exercise-and-cognitive-performance.en.json';
import article83 from './articles/fluid-intelligence.en.json';
import article84 from './articles/flynn-effect.en.json';
import article85 from './articles/free-online-iq-test-guide.ar.json';
import article86 from './articles/free-online-iq-test-guide.bn.json';
import article87 from './articles/free-online-iq-test-guide.en.json';
import article88 from './articles/free-online-iq-test-guide.es.json';
import article89 from './articles/free-online-iq-test-guide.fr.json';
import article90 from './articles/free-online-iq-test-guide.hi.json';
import article91 from './articles/free-online-iq-test-guide.id.json';
import article92 from './articles/free-online-iq-test-guide.ja.json';
import article93 from './articles/free-online-iq-test-guide.ko.json';
import article94 from './articles/free-online-iq-test-guide.ru.json';
import article95 from './articles/free-online-iq-test-guide.zh.json';
import article96 from './articles/free-vs-paid-iq-tests.en.json';
import article97 from './articles/full-scale-iq-vs-index-scores.en.json';
import article98 from './articles/general-intelligence-g-factor-explained.en.json';
import article99 from './articles/healthy-cognitive-aging-explained.en.json';
import article100 from './articles/highest-iq-ever-recorded.ar.json';
import article101 from './articles/highest-iq-ever-recorded.bn.json';
import article102 from './articles/highest-iq-ever-recorded.en.json';
import article103 from './articles/highest-iq-ever-recorded.es.json';
import article104 from './articles/highest-iq-ever-recorded.fr.json';
import article105 from './articles/highest-iq-ever-recorded.hi.json';
import article106 from './articles/highest-iq-ever-recorded.zh.json';
import article107 from './articles/historical-iq-trends.en.json';
import article108 from './articles/how-can-i-find-out-my-iq.ar.json';
import article109 from './articles/how-can-i-find-out-my-iq.bn.json';
import article110 from './articles/how-can-i-find-out-my-iq.en.json';
import article111 from './articles/how-can-i-find-out-my-iq.es.json';
import article112 from './articles/how-can-i-find-out-my-iq.fr.json';
import article113 from './articles/how-can-i-find-out-my-iq.hi.json';
import article114 from './articles/how-can-i-find-out-my-iq.zh.json';
import article115 from './articles/how-iq-tests-are-standardized-and-normed.en.json';
import article116 from './articles/how-is-iq-measured.ar.json';
import article117 from './articles/how-is-iq-measured.bn.json';
import article118 from './articles/how-is-iq-measured.en.json';
import article119 from './articles/how-is-iq-measured.es.json';
import article120 from './articles/how-is-iq-measured.fr.json';
import article121 from './articles/how-is-iq-measured.hi.json';
import article122 from './articles/how-is-iq-measured.zh.json';
import article123 from './articles/how-long-does-an-iq-test-take.en.json';
import article124 from './articles/how-much-profile-scatter-is-normal.en.json';
import article125 from './articles/how-soon-can-you-retake-an-iq-test.en.json';
import article126 from './articles/how-to-explain-iq-confidence-intervals.en.json';
import article127 from './articles/how-to-prepare-for-an-iq-test.en.json';
import article128 from './articles/how-to-read-an-iq-test-report.en.json';
import article129 from './articles/how-to-solve-pattern-rules.en.json';
import article130 from './articles/how-to-take-an-iq-test.en.json';
import article131 from './articles/how-to-talk-about-iq-results.en.json';
import article132 from './articles/hydration-and-cognitive-testing.en.json';
import article133 from './articles/inductive-reasoning-explained.en.json';
import article134 from './articles/intelligence-research-how-to-read-a-new-study.en.json';
import article135 from './articles/interruptions-during-online-iq-tests.en.json';
import article136 from './articles/iq-100-meaning.en.json';
import article137 from './articles/iq-110-meaning.en.json';
import article138 from './articles/iq-130-meaning.en.json';
import article139 from './articles/iq-145-meaning.en.json';
import article140 from './articles/iq-160-meaning.en.json';
import article141 from './articles/iq-80-meaning.en.json';
import article142 from './articles/iq-90-meaning.en.json';
import article143 from './articles/iq-distribution.ar.json';
import article144 from './articles/iq-distribution.bn.json';
import article145 from './articles/iq-distribution.en.json';
import article146 from './articles/iq-distribution.es.json';
import article147 from './articles/iq-distribution.fr.json';
import article148 from './articles/iq-distribution.hi.json';
import article149 from './articles/iq-distribution.zh.json';
import article150 from './articles/iq-full-form.en.json';
import article151 from './articles/iq-games-and-brain-puzzles.en.json';
import article152 from './articles/iq-percentile-calculator.en.json';
import article153 from './articles/iq-percentile-vs-percent-correct.en.json';
import article154 from './articles/iq-percentiles.ar.json';
import article155 from './articles/iq-percentiles.bn.json';
import article156 from './articles/iq-percentiles.en.json';
import article157 from './articles/iq-percentiles.es.json';
import article158 from './articles/iq-percentiles.fr.json';
import article159 from './articles/iq-percentiles.hi.json';
import article160 from './articles/iq-percentiles.zh.json';
import article161 from './articles/iq-score-classification-labels.en.json';
import article162 from './articles/iq-score-confidence-intervals.en.json';
import article163 from './articles/iq-score-ranges-explained.ar.json';
import article164 from './articles/iq-score-ranges-explained.bn.json';
import article165 from './articles/iq-score-ranges-explained.en.json';
import article166 from './articles/iq-score-ranges-explained.es.json';
import article167 from './articles/iq-score-ranges-explained.fr.json';
import article168 from './articles/iq-score-ranges-explained.hi.json';
import article169 from './articles/iq-score-ranges-explained.zh.json';
import article170 from './articles/iq-test-accommodations-and-accessibility.en.json';
import article171 from './articles/iq-test-instructions-explained.en.json';
import article172 from './articles/iq-test-reliability.en.json';
import article173 from './articles/iq-test-validity.en.json';
import article174 from './articles/iq-test-vs-mensa-test.en.json';
import article175 from './articles/iq-test-vs-neuropsychological-assessment.en.json';
import article176 from './articles/iq-testing-for-adults.en.json';
import article177 from './articles/iq-testing-for-older-adults.en.json';
import article178 from './articles/iq-testing-for-teenagers.en.json';
import article179 from './articles/iq-testing-for-young-children.en.json';
import article180 from './articles/iq-tests-and-gifted-identification.en.json';
import article181 from './articles/iq-tests-and-learning-difficulties.en.json';
import article182 from './articles/iq-vs-achievement-tests.en.json';
import article183 from './articles/iq-vs-aptitude-tests.en.json';
import article184 from './articles/iq-vs-creativity.en.json';
import article185 from './articles/iq-vs-critical-thinking.en.json';
import article186 from './articles/iq-vs-emotional-intelligence.en.json';
import article187 from './articles/iq-vs-eq.ar.json';
import article188 from './articles/iq-vs-eq.bn.json';
import article189 from './articles/iq-vs-eq.en.json';
import article190 from './articles/iq-vs-eq.es.json';
import article191 from './articles/iq-vs-eq.fr.json';
import article192 from './articles/iq-vs-eq.hi.json';
import article193 from './articles/iq-vs-eq.zh.json';
import article194 from './articles/iq-vs-executive-function.en.json';
import article195 from './articles/iq-vs-gpa.en.json';
import article196 from './articles/iq-vs-intelligence.ar.json';
import article197 from './articles/iq-vs-intelligence.bn.json';
import article198 from './articles/iq-vs-intelligence.en.json';
import article199 from './articles/iq-vs-intelligence.es.json';
import article200 from './articles/iq-vs-intelligence.fr.json';
import article201 from './articles/iq-vs-intelligence.hi.json';
import article202 from './articles/iq-vs-intelligence.zh.json';
import article203 from './articles/iq-vs-knowledge.en.json';
import article204 from './articles/iq-vs-memory.en.json';
import article205 from './articles/iq-vs-personality.en.json';
import article206 from './articles/iq-vs-problem-solving.en.json';
import article207 from './articles/iq-vs-sat.en.json';
import article208 from './articles/iq-vs-wisdom.en.json';
import article209 from './articles/is-an-online-iq-test-accurate.ar.json';
import article210 from './articles/is-an-online-iq-test-accurate.bn.json';
import article211 from './articles/is-an-online-iq-test-accurate.en.json';
import article212 from './articles/is-an-online-iq-test-accurate.es.json';
import article213 from './articles/is-an-online-iq-test-accurate.fr.json';
import article214 from './articles/is-an-online-iq-test-accurate.hi.json';
import article215 from './articles/is-an-online-iq-test-accurate.zh.json';
import article216 from './articles/is-iq-fixed-at-birth.en.json';
import article217 from './articles/is-iq-genetic.ar.json';
import article218 from './articles/is-iq-genetic.bn.json';
import article219 from './articles/is-iq-genetic.en.json';
import article220 from './articles/is-iq-genetic.es.json';
import article221 from './articles/is-iq-genetic.fr.json';
import article222 from './articles/is-iq-genetic.hi.json';
import article223 from './articles/is-iq-genetic.zh.json';
import article224 from './articles/isaac-newton-iq.en.json';
import article225 from './articles/item-difficulty-in-iq-tests.en.json';
import article226 from './articles/item-discrimination-in-iq-tests.en.json';
import article227 from './articles/learning-style-quiz.en.json';
import article228 from './articles/leonardo-da-vinci-iq.en.json';
import article229 from './articles/light-yagami-iq.en.json';
import article230 from './articles/logic-puzzles.en.json';
import article231 from './articles/logical-sequences-practice.en.json';
import article232 from './articles/low-iq-scores-explained.ar.json';
import article233 from './articles/low-iq-scores-explained.bn.json';
import article234 from './articles/low-iq-scores-explained.en.json';
import article235 from './articles/low-iq-scores-explained.es.json';
import article236 from './articles/low-iq-scores-explained.fr.json';
import article237 from './articles/low-iq-scores-explained.hi.json';
import article238 from './articles/low-iq-scores-explained.zh.json';
import article239 from './articles/marie-curie-iq.en.json';
import article240 from './articles/matrix-reasoning-practice.en.json';
import article241 from './articles/matrix-reasoning-strategies.en.json';
import article242 from './articles/measurement-invariance-iq-tests.en.json';
import article243 from './articles/memory-exercises.en.json';
import article244 from './articles/memory-research-explained.en.json';
import article245 from './articles/memory-test.en.json';
import article246 from './articles/mensa-iq-requirements.ar.json';
import article247 from './articles/mensa-iq-requirements.bn.json';
import article248 from './articles/mensa-iq-requirements.en.json';
import article249 from './articles/mensa-iq-requirements.es.json';
import article250 from './articles/mensa-iq-requirements.fr.json';
import article251 from './articles/mensa-iq-requirements.hi.json';
import article252 from './articles/mensa-iq-requirements.zh.json';
import article253 from './articles/mental-age-calculator.en.json';
import article254 from './articles/mental-math.en.json';
import article255 from './articles/metacognition-and-problem-solving.en.json';
import article256 from './articles/multilingual-learners-and-iq-tests.en.json';
import article257 from './articles/neuroplasticity-and-intelligence.en.json';
import article258 from './articles/nikola-tesla-iq.en.json';
import article259 from './articles/nonverbal-reasoning-explained.en.json';
import article260 from './articles/norm-referenced-testing-explained.en.json';
import article261 from './articles/number-sequence-strategies.en.json';
import article262 from './articles/number-series-practice.en.json';
import article263 from './articles/nutrition-and-cognitive-performance.en.json';
import article264 from './articles/odd-one-out-reasoning-guide.en.json';
import article265 from './articles/paper-folding-spatial-strategies.en.json';
import article266 from './articles/patrick-jane-iq.en.json';
import article267 from './articles/percentile-rank-in-iq-testing.en.json';
import article268 from './articles/practice-effects-on-iq-tests.en.json';
import article269 from './articles/processing-speed-explained.en.json';
import article270 from './articles/processing-speed-games.en.json';
import article271 from './articles/quantitative-reasoning-explained.en.json';
import article272 from './articles/ravens-progressive-matrices.en.json';
import article273 from './articles/raw-scores-vs-scaled-iq-scores.en.json';
import article274 from './articles/reaction-time-test.en.json';
import article275 from './articles/regression-to-the-mean-iq-scores.en.json';
import article276 from './articles/rowan-atkinson-iq.en.json';
import article277 from './articles/sampling-error-in-test-norms.en.json';
import article278 from './articles/screen-size-and-online-iq-tests.en.json';
import article279 from './articles/short-term-memory-vs-working-memory.en.json';
import article280 from './articles/should-you-guess-on-an-iq-test.en.json';
import article281 from './articles/sleep-before-cognitive-testing.en.json';
import article282 from './articles/spatial-rotation-questions.en.json';
import article283 from './articles/speed-accuracy-balance-in-tests.en.json';
import article284 from './articles/standard-deviation-explained.en.json';
import article285 from './articles/standard-error-of-measurement-iq.en.json';
import article286 from './articles/stanford-binet-intelligence-scales.en.json';
import article287 from './articles/stanines-and-cognitive-scores.en.json';
import article288 from './articles/stephen-hawking-iq.en.json';
import article289 from './articles/stress-and-cognitive-performance.en.json';
import article290 from './articles/sudoku-strategies.en.json';
import article291 from './articles/supervised-vs-unsupervised-iq-tests.en.json';
import article292 from './articles/syllogism-practice-strategies.en.json';
import article293 from './articles/taking-an-iq-test-when-sick.en.json';
import article294 from './articles/test-anxiety-and-iq-performance.en.json';
import article295 from './articles/test-retest-reliability-iq.en.json';
import article296 from './articles/time-pressure-in-iq-tests.en.json';
import article297 from './articles/twice-exceptional-learners-and-iq.en.json';
import article298 from './articles/understanding-iq-score-discrepancies.en.json';
import article299 from './articles/using-cognitive-tests-in-workplace-decisions.en.json';
import article300 from './articles/using-iq-results-in-school-decisions.en.json';
import article301 from './articles/verbal-analogy-strategies.en.json';
import article302 from './articles/verbal-reasoning-explained.en.json';
import article303 from './articles/visual-reasoning-practice.en.json';
import article304 from './articles/visual-spatial-reasoning-explained.en.json';
import article305 from './articles/wais-intelligence-test.en.json';
import article306 from './articles/what-age-should-children-take-an-iq-test.en.json';
import article307 from './articles/what-does-an-iq-of-120-mean.en.json';
import article308 from './articles/what-does-an-iq-of-140-mean.en.json';
import article309 from './articles/what-is-an-iq-test.en.json';
import article310 from './articles/what-is-considered-a-high-iq.ar.json';
import article311 from './articles/what-is-considered-a-high-iq.bn.json';
import article312 from './articles/what-is-considered-a-high-iq.en.json';
import article313 from './articles/what-is-considered-a-high-iq.es.json';
import article314 from './articles/what-is-considered-a-high-iq.fr.json';
import article315 from './articles/what-is-considered-a-high-iq.hi.json';
import article316 from './articles/what-is-considered-a-high-iq.zh.json';
import article317 from './articles/what-is-iq.ar.json';
import article318 from './articles/what-is-iq.bn.json';
import article319 from './articles/what-is-iq.en.json';
import article320 from './articles/what-is-iq.es.json';
import article321 from './articles/what-is-iq.fr.json';
import article322 from './articles/what-is-iq.hi.json';
import article323 from './articles/what-is-iq.ja.json';
import article324 from './articles/what-is-iq.zh.json';
import article325 from './articles/what-is-the-average-iq.ar.json';
import article326 from './articles/what-is-the-average-iq.bn.json';
import article327 from './articles/what-is-the-average-iq.en.json';
import article328 from './articles/what-is-the-average-iq.es.json';
import article329 from './articles/what-is-the-average-iq.fr.json';
import article330 from './articles/what-is-the-average-iq.hi.json';
import article331 from './articles/what-is-the-average-iq.ja.json';
import article332 from './articles/what-is-the-average-iq.zh.json';
import article333 from './articles/what-makes-a-good-iq-norm-sample.en.json';
import article334 from './articles/what-questions-are-on-an-iq-test.en.json';
import article335 from './articles/when-to-seek-a-second-opinion-on-testing.en.json';
import article336 from './articles/why-iq-alone-cannot-diagnose.en.json';
import article337 from './articles/why-iq-scores-vary-between-tests.en.json';
import article338 from './articles/working-memory-explained.en.json';
import article339 from './articles/working-memory-practice-strategies.en.json';
import article340 from './articles/z-scores-and-iq.en.json';

export interface ContentArticleEntry {
  language: string;
  page: ContentPage;
}

export const CONTENT_ARTICLE_ENTRIES: ContentArticleEntry[] = [
  { language: 'en', page: article1 as ContentPage },
  { language: 'en', page: article2 as ContentPage },
  { language: 'en', page: article3 as ContentPage },
  { language: 'en', page: article4 as ContentPage },
  { language: 'en', page: article5 as ContentPage },
  { language: 'en', page: article6 as ContentPage },
  { language: 'en', page: article7 as ContentPage },
  { language: 'en', page: article8 as ContentPage },
  { language: 'en', page: article9 as ContentPage },
  { language: 'en', page: article10 as ContentPage },
  { language: 'en', page: article11 as ContentPage },
  { language: 'en', page: article12 as ContentPage },
  { language: 'en', page: article13 as ContentPage },
  { language: 'es', page: article14 as ContentPage },
  { language: 'en', page: article15 as ContentPage },
  { language: 'en', page: article16 as ContentPage },
  { language: 'en', page: article17 as ContentPage },
  { language: 'en', page: article18 as ContentPage },
  { language: 'en', page: article19 as ContentPage },
  { language: 'en', page: article20 as ContentPage },
  { language: 'en', page: article21 as ContentPage },
  { language: 'ar', page: article22 as ContentPage },
  { language: 'bn', page: article23 as ContentPage },
  { language: 'en', page: article24 as ContentPage },
  { language: 'es', page: article25 as ContentPage },
  { language: 'fr', page: article26 as ContentPage },
  { language: 'hi', page: article27 as ContentPage },
  { language: 'zh', page: article28 as ContentPage },
  { language: 'en', page: article29 as ContentPage },
  { language: 'ar', page: article30 as ContentPage },
  { language: 'bn', page: article31 as ContentPage },
  { language: 'en', page: article32 as ContentPage },
  { language: 'es', page: article33 as ContentPage },
  { language: 'fr', page: article34 as ContentPage },
  { language: 'hi', page: article35 as ContentPage },
  { language: 'zh', page: article36 as ContentPage },
  { language: 'en', page: article37 as ContentPage },
  { language: 'ar', page: article38 as ContentPage },
  { language: 'bn', page: article39 as ContentPage },
  { language: 'en', page: article40 as ContentPage },
  { language: 'es', page: article41 as ContentPage },
  { language: 'fr', page: article42 as ContentPage },
  { language: 'hi', page: article43 as ContentPage },
  { language: 'zh', page: article44 as ContentPage },
  { language: 'en', page: article45 as ContentPage },
  { language: 'en', page: article46 as ContentPage },
  { language: 'en', page: article47 as ContentPage },
  { language: 'en', page: article48 as ContentPage },
  { language: 'en', page: article49 as ContentPage },
  { language: 'en', page: article50 as ContentPage },
  { language: 'en', page: article51 as ContentPage },
  { language: 'en', page: article52 as ContentPage },
  { language: 'en', page: article53 as ContentPage },
  { language: 'en', page: article54 as ContentPage },
  { language: 'en', page: article55 as ContentPage },
  { language: 'en', page: article56 as ContentPage },
  { language: 'en', page: article57 as ContentPage },
  { language: 'en', page: article58 as ContentPage },
  { language: 'en', page: article59 as ContentPage },
  { language: 'en', page: article60 as ContentPage },
  { language: 'en', page: article61 as ContentPage },
  { language: 'en', page: article62 as ContentPage },
  { language: 'en', page: article63 as ContentPage },
  { language: 'en', page: article64 as ContentPage },
  { language: 'en', page: article65 as ContentPage },
  { language: 'en', page: article66 as ContentPage },
  { language: 'en', page: article67 as ContentPage },
  { language: 'en', page: article68 as ContentPage },
  { language: 'en', page: article69 as ContentPage },
  { language: 'en', page: article70 as ContentPage },
  { language: 'en', page: article71 as ContentPage },
  { language: 'ar', page: article72 as ContentPage },
  { language: 'bn', page: article73 as ContentPage },
  { language: 'en', page: article74 as ContentPage },
  { language: 'es', page: article75 as ContentPage },
  { language: 'fr', page: article76 as ContentPage },
  { language: 'hi', page: article77 as ContentPage },
  { language: 'zh', page: article78 as ContentPage },
  { language: 'en', page: article79 as ContentPage },
  { language: 'en', page: article80 as ContentPage },
  { language: 'en', page: article81 as ContentPage },
  { language: 'en', page: article82 as ContentPage },
  { language: 'en', page: article83 as ContentPage },
  { language: 'en', page: article84 as ContentPage },
  { language: 'ar', page: article85 as ContentPage },
  { language: 'bn', page: article86 as ContentPage },
  { language: 'en', page: article87 as ContentPage },
  { language: 'es', page: article88 as ContentPage },
  { language: 'fr', page: article89 as ContentPage },
  { language: 'hi', page: article90 as ContentPage },
  { language: 'id', page: article91 as ContentPage },
  { language: 'ja', page: article92 as ContentPage },
  { language: 'ko', page: article93 as ContentPage },
  { language: 'ru', page: article94 as ContentPage },
  { language: 'zh', page: article95 as ContentPage },
  { language: 'en', page: article96 as ContentPage },
  { language: 'en', page: article97 as ContentPage },
  { language: 'en', page: article98 as ContentPage },
  { language: 'en', page: article99 as ContentPage },
  { language: 'ar', page: article100 as ContentPage },
  { language: 'bn', page: article101 as ContentPage },
  { language: 'en', page: article102 as ContentPage },
  { language: 'es', page: article103 as ContentPage },
  { language: 'fr', page: article104 as ContentPage },
  { language: 'hi', page: article105 as ContentPage },
  { language: 'zh', page: article106 as ContentPage },
  { language: 'en', page: article107 as ContentPage },
  { language: 'ar', page: article108 as ContentPage },
  { language: 'bn', page: article109 as ContentPage },
  { language: 'en', page: article110 as ContentPage },
  { language: 'es', page: article111 as ContentPage },
  { language: 'fr', page: article112 as ContentPage },
  { language: 'hi', page: article113 as ContentPage },
  { language: 'zh', page: article114 as ContentPage },
  { language: 'en', page: article115 as ContentPage },
  { language: 'ar', page: article116 as ContentPage },
  { language: 'bn', page: article117 as ContentPage },
  { language: 'en', page: article118 as ContentPage },
  { language: 'es', page: article119 as ContentPage },
  { language: 'fr', page: article120 as ContentPage },
  { language: 'hi', page: article121 as ContentPage },
  { language: 'zh', page: article122 as ContentPage },
  { language: 'en', page: article123 as ContentPage },
  { language: 'en', page: article124 as ContentPage },
  { language: 'en', page: article125 as ContentPage },
  { language: 'en', page: article126 as ContentPage },
  { language: 'en', page: article127 as ContentPage },
  { language: 'en', page: article128 as ContentPage },
  { language: 'en', page: article129 as ContentPage },
  { language: 'en', page: article130 as ContentPage },
  { language: 'en', page: article131 as ContentPage },
  { language: 'en', page: article132 as ContentPage },
  { language: 'en', page: article133 as ContentPage },
  { language: 'en', page: article134 as ContentPage },
  { language: 'en', page: article135 as ContentPage },
  { language: 'en', page: article136 as ContentPage },
  { language: 'en', page: article137 as ContentPage },
  { language: 'en', page: article138 as ContentPage },
  { language: 'en', page: article139 as ContentPage },
  { language: 'en', page: article140 as ContentPage },
  { language: 'en', page: article141 as ContentPage },
  { language: 'en', page: article142 as ContentPage },
  { language: 'ar', page: article143 as ContentPage },
  { language: 'bn', page: article144 as ContentPage },
  { language: 'en', page: article145 as ContentPage },
  { language: 'es', page: article146 as ContentPage },
  { language: 'fr', page: article147 as ContentPage },
  { language: 'hi', page: article148 as ContentPage },
  { language: 'zh', page: article149 as ContentPage },
  { language: 'en', page: article150 as ContentPage },
  { language: 'en', page: article151 as ContentPage },
  { language: 'en', page: article152 as ContentPage },
  { language: 'en', page: article153 as ContentPage },
  { language: 'ar', page: article154 as ContentPage },
  { language: 'bn', page: article155 as ContentPage },
  { language: 'en', page: article156 as ContentPage },
  { language: 'es', page: article157 as ContentPage },
  { language: 'fr', page: article158 as ContentPage },
  { language: 'hi', page: article159 as ContentPage },
  { language: 'zh', page: article160 as ContentPage },
  { language: 'en', page: article161 as ContentPage },
  { language: 'en', page: article162 as ContentPage },
  { language: 'ar', page: article163 as ContentPage },
  { language: 'bn', page: article164 as ContentPage },
  { language: 'en', page: article165 as ContentPage },
  { language: 'es', page: article166 as ContentPage },
  { language: 'fr', page: article167 as ContentPage },
  { language: 'hi', page: article168 as ContentPage },
  { language: 'zh', page: article169 as ContentPage },
  { language: 'en', page: article170 as ContentPage },
  { language: 'en', page: article171 as ContentPage },
  { language: 'en', page: article172 as ContentPage },
  { language: 'en', page: article173 as ContentPage },
  { language: 'en', page: article174 as ContentPage },
  { language: 'en', page: article175 as ContentPage },
  { language: 'en', page: article176 as ContentPage },
  { language: 'en', page: article177 as ContentPage },
  { language: 'en', page: article178 as ContentPage },
  { language: 'en', page: article179 as ContentPage },
  { language: 'en', page: article180 as ContentPage },
  { language: 'en', page: article181 as ContentPage },
  { language: 'en', page: article182 as ContentPage },
  { language: 'en', page: article183 as ContentPage },
  { language: 'en', page: article184 as ContentPage },
  { language: 'en', page: article185 as ContentPage },
  { language: 'en', page: article186 as ContentPage },
  { language: 'ar', page: article187 as ContentPage },
  { language: 'bn', page: article188 as ContentPage },
  { language: 'en', page: article189 as ContentPage },
  { language: 'es', page: article190 as ContentPage },
  { language: 'fr', page: article191 as ContentPage },
  { language: 'hi', page: article192 as ContentPage },
  { language: 'zh', page: article193 as ContentPage },
  { language: 'en', page: article194 as ContentPage },
  { language: 'en', page: article195 as ContentPage },
  { language: 'ar', page: article196 as ContentPage },
  { language: 'bn', page: article197 as ContentPage },
  { language: 'en', page: article198 as ContentPage },
  { language: 'es', page: article199 as ContentPage },
  { language: 'fr', page: article200 as ContentPage },
  { language: 'hi', page: article201 as ContentPage },
  { language: 'zh', page: article202 as ContentPage },
  { language: 'en', page: article203 as ContentPage },
  { language: 'en', page: article204 as ContentPage },
  { language: 'en', page: article205 as ContentPage },
  { language: 'en', page: article206 as ContentPage },
  { language: 'en', page: article207 as ContentPage },
  { language: 'en', page: article208 as ContentPage },
  { language: 'ar', page: article209 as ContentPage },
  { language: 'bn', page: article210 as ContentPage },
  { language: 'en', page: article211 as ContentPage },
  { language: 'es', page: article212 as ContentPage },
  { language: 'fr', page: article213 as ContentPage },
  { language: 'hi', page: article214 as ContentPage },
  { language: 'zh', page: article215 as ContentPage },
  { language: 'en', page: article216 as ContentPage },
  { language: 'ar', page: article217 as ContentPage },
  { language: 'bn', page: article218 as ContentPage },
  { language: 'en', page: article219 as ContentPage },
  { language: 'es', page: article220 as ContentPage },
  { language: 'fr', page: article221 as ContentPage },
  { language: 'hi', page: article222 as ContentPage },
  { language: 'zh', page: article223 as ContentPage },
  { language: 'en', page: article224 as ContentPage },
  { language: 'en', page: article225 as ContentPage },
  { language: 'en', page: article226 as ContentPage },
  { language: 'en', page: article227 as ContentPage },
  { language: 'en', page: article228 as ContentPage },
  { language: 'en', page: article229 as ContentPage },
  { language: 'en', page: article230 as ContentPage },
  { language: 'en', page: article231 as ContentPage },
  { language: 'ar', page: article232 as ContentPage },
  { language: 'bn', page: article233 as ContentPage },
  { language: 'en', page: article234 as ContentPage },
  { language: 'es', page: article235 as ContentPage },
  { language: 'fr', page: article236 as ContentPage },
  { language: 'hi', page: article237 as ContentPage },
  { language: 'zh', page: article238 as ContentPage },
  { language: 'en', page: article239 as ContentPage },
  { language: 'en', page: article240 as ContentPage },
  { language: 'en', page: article241 as ContentPage },
  { language: 'en', page: article242 as ContentPage },
  { language: 'en', page: article243 as ContentPage },
  { language: 'en', page: article244 as ContentPage },
  { language: 'en', page: article245 as ContentPage },
  { language: 'ar', page: article246 as ContentPage },
  { language: 'bn', page: article247 as ContentPage },
  { language: 'en', page: article248 as ContentPage },
  { language: 'es', page: article249 as ContentPage },
  { language: 'fr', page: article250 as ContentPage },
  { language: 'hi', page: article251 as ContentPage },
  { language: 'zh', page: article252 as ContentPage },
  { language: 'en', page: article253 as ContentPage },
  { language: 'en', page: article254 as ContentPage },
  { language: 'en', page: article255 as ContentPage },
  { language: 'en', page: article256 as ContentPage },
  { language: 'en', page: article257 as ContentPage },
  { language: 'en', page: article258 as ContentPage },
  { language: 'en', page: article259 as ContentPage },
  { language: 'en', page: article260 as ContentPage },
  { language: 'en', page: article261 as ContentPage },
  { language: 'en', page: article262 as ContentPage },
  { language: 'en', page: article263 as ContentPage },
  { language: 'en', page: article264 as ContentPage },
  { language: 'en', page: article265 as ContentPage },
  { language: 'en', page: article266 as ContentPage },
  { language: 'en', page: article267 as ContentPage },
  { language: 'en', page: article268 as ContentPage },
  { language: 'en', page: article269 as ContentPage },
  { language: 'en', page: article270 as ContentPage },
  { language: 'en', page: article271 as ContentPage },
  { language: 'en', page: article272 as ContentPage },
  { language: 'en', page: article273 as ContentPage },
  { language: 'en', page: article274 as ContentPage },
  { language: 'en', page: article275 as ContentPage },
  { language: 'en', page: article276 as ContentPage },
  { language: 'en', page: article277 as ContentPage },
  { language: 'en', page: article278 as ContentPage },
  { language: 'en', page: article279 as ContentPage },
  { language: 'en', page: article280 as ContentPage },
  { language: 'en', page: article281 as ContentPage },
  { language: 'en', page: article282 as ContentPage },
  { language: 'en', page: article283 as ContentPage },
  { language: 'en', page: article284 as ContentPage },
  { language: 'en', page: article285 as ContentPage },
  { language: 'en', page: article286 as ContentPage },
  { language: 'en', page: article287 as ContentPage },
  { language: 'en', page: article288 as ContentPage },
  { language: 'en', page: article289 as ContentPage },
  { language: 'en', page: article290 as ContentPage },
  { language: 'en', page: article291 as ContentPage },
  { language: 'en', page: article292 as ContentPage },
  { language: 'en', page: article293 as ContentPage },
  { language: 'en', page: article294 as ContentPage },
  { language: 'en', page: article295 as ContentPage },
  { language: 'en', page: article296 as ContentPage },
  { language: 'en', page: article297 as ContentPage },
  { language: 'en', page: article298 as ContentPage },
  { language: 'en', page: article299 as ContentPage },
  { language: 'en', page: article300 as ContentPage },
  { language: 'en', page: article301 as ContentPage },
  { language: 'en', page: article302 as ContentPage },
  { language: 'en', page: article303 as ContentPage },
  { language: 'en', page: article304 as ContentPage },
  { language: 'en', page: article305 as ContentPage },
  { language: 'en', page: article306 as ContentPage },
  { language: 'en', page: article307 as ContentPage },
  { language: 'en', page: article308 as ContentPage },
  { language: 'en', page: article309 as ContentPage },
  { language: 'ar', page: article310 as ContentPage },
  { language: 'bn', page: article311 as ContentPage },
  { language: 'en', page: article312 as ContentPage },
  { language: 'es', page: article313 as ContentPage },
  { language: 'fr', page: article314 as ContentPage },
  { language: 'hi', page: article315 as ContentPage },
  { language: 'zh', page: article316 as ContentPage },
  { language: 'ar', page: article317 as ContentPage },
  { language: 'bn', page: article318 as ContentPage },
  { language: 'en', page: article319 as ContentPage },
  { language: 'es', page: article320 as ContentPage },
  { language: 'fr', page: article321 as ContentPage },
  { language: 'hi', page: article322 as ContentPage },
  { language: 'ja', page: article323 as ContentPage },
  { language: 'zh', page: article324 as ContentPage },
  { language: 'ar', page: article325 as ContentPage },
  { language: 'bn', page: article326 as ContentPage },
  { language: 'en', page: article327 as ContentPage },
  { language: 'es', page: article328 as ContentPage },
  { language: 'fr', page: article329 as ContentPage },
  { language: 'hi', page: article330 as ContentPage },
  { language: 'ja', page: article331 as ContentPage },
  { language: 'zh', page: article332 as ContentPage },
  { language: 'en', page: article333 as ContentPage },
  { language: 'en', page: article334 as ContentPage },
  { language: 'en', page: article335 as ContentPage },
  { language: 'en', page: article336 as ContentPage },
  { language: 'en', page: article337 as ContentPage },
  { language: 'en', page: article338 as ContentPage },
  { language: 'en', page: article339 as ContentPage },
  { language: 'en', page: article340 as ContentPage },
];
